import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AddonsAccessService } from '../addons/addons-subscribtion/addons-access.service';

@Injectable({ providedIn: 'root' })
export class AddonGuard implements CanActivate {

  constructor(
    private addonsAccess: AddonsAccessService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const addonKey = route.data['addon'] as string | undefined;

    // No addon required → allow access
    if (!addonKey) return true;

    // Allow if addon OR bundle is active
    const isAllowed =
      this.addonsAccess.isAddonActive(addonKey) ||
      this.addonsAccess.isAddonActive('All Addons Bundle');

    if (isAllowed) return true;

    // ❌ Block access → redirect
    return this.router.createUrlTree(['/'])
  }
}
